import Container from "./Container";

export default function Section({ id, label, labelClass = "", title, children }) {
  return (
    <section id={id} className="border-t border-[var(--line)] py-14 md:py-16">
      <Container>
        <div className="grid gap-6 md:grid-cols-12 md:gap-8">
          <h2 className={`kicker md:col-span-3 md:pt-1 ${labelClass}`}>{label}</h2>
          <div className="md:col-span-9 md:col-start-4">
            {title ? (
              <p className="text-2xl font-semibold leading-snug tracking-tight text-[var(--ink)]">
                {title}
              </p>
            ) : null}
            <div className={title ? "mt-5" : undefined}>{children}</div>
          </div>
        </div>
      </Container>
    </section>
  );
}
